import Vue from 'vue'
import moment from 'moment'

export default {
  register() {
    Vue.filter('plain', function(val) {
      return val.replace(/<br \/>/g, '')
    })
    Vue.filter('format', function(val, f) {
      if (!isNaN(val)) {
        // number
        return String(val).replace(/(.)(?=(\d{3})+$)/g, '$1.')
      } else if (typeof val === 'string') {
        if (String(val).match(/\d{4}-\d{2}-\d{2}/)) {
          if (f == 'fromNow') return moment(val).fromNow()
          else return moment(val).format(f ? f : 'DD-MMM-YYYY')
        } else {
          return val
        }
      } else if (typeof val === 'object') {
        if (val.getDate) {
          if (f == 'fromNow') return moment(val).fromNow()
          else return moment(val).format(f ? f : 'DD-MMM-YYYY')
        } else {
          return val
        }
      }
      return val
    })
  },
}
